import type { RoutesType, SearchTypes, SponsoredTripType, TripsType } from '../../models';

export type Search = SearchTypes & {
  flights: TripsType;
  sponsoredTrips: SponsoredTripType;
  routes: RoutesType;
};

export const SearchRouteCodeKind = {
  ORIGIN_CODE: 'originCode',
  DESTINATION_CODE: 'destinationCode',
} as const;
export type SearchRouteCodeKindType =
  (typeof SearchRouteCodeKind)[keyof typeof SearchRouteCodeKind];

export type QuickSortPricesType = {
  bestValue: number;
  carrierPromo: number;
  cheapTrip: number;
  recommendation: number;
  shortTrip: number;
  longStay: number;
} | null;
